<template>
    <div class="history-list m-auto">
        <HistoryEarnItem
                v-for="(earnpoint) in earnpoints"
                :key="earnpoint.RowKey"
                :earnpoint="earnpoint"
        ></HistoryEarnItem>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
//component
import HistoryEarnItem from './HistoryEarnItem.vue';
//service
import BzbsPoint from '@/core/Point/service/BzbsPoint';


export default {
    name: 'HistoryEarnList',
    components: {
        HistoryEarnItem
    },
    props: {
        initListConfig:     { type: Object, required: true },
        modalController:{ type: Object, required: true },
    },
    data: function() {
        return {
            listConfig: null,

            earnpoints: [],
            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
        };
    },
    created: function() {
        this.listConfig = this.initListConfig;

        this.getList();
    },
    methods: {
        reinitList: function(listConfig) {
            this.listConfig = listConfig;
            this.earnpoints = [];
            this.getList();
        },
        //#region history list
        getList: function () {
            return new Promise((resolve) => {
                this.isLoading = true;
                BzbsPoint.apiGetPointHistory(this.listConfig).subscribe((earnpoints) => {
                    Util.log('points list', earnpoints);

                    if (earnpoints && earnpoints.length == this.listConfig.top) {
                        this.listConfig.increstSkip(earnpoints[this.listConfig.top - 1].RowKey);
                    }

                    //check is there are more campaign.
                    if (earnpoints && earnpoints.length < this.listConfig.top) {
                        this.listConfig.setSeeMoreEnable(false);
                    }
                    //reinitialize list if no skip.
                    if (this.listConfig.lastRowKey == null) {
                        this.earnpoints = [];
                    }

                    for (let earnpoint of earnpoints) {
                        //TODO: Add GA Tracking.
                        this.earnpoints.push(earnpoint);
                    }

                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = this.earnpoints.length > 0 ? true : false;
                    resolve();
                }, (err) => {
                    resolve();
                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.errorApi(err);
                });
            });
        },

        loadMore: function() {
            if (!this.listConfig.isSeeMoreEnable) {
                return;
            }
            if (this.isLoading) {
                return;
            }
            this.getList();
        },
        //#endregion history list

        //#region action history

        //#endregion action history
    },
}
</script>
<style lang="scss" scoped>
    .history-list {
        max-width: 500px;
    }
</style>
